import styled from "styled-components"
import PrimaryButton from "components/Ui/Buttons/PrimaryButton"

export const Container = styled.div`
  width: 100%;
  min-height: 20rem;
  position: relative;
`

export const StyledButton = styled(PrimaryButton)`
  width: 20rem;
`
